import { useMemo, useCallback } from 'react';
import { useTenantSettings } from './useTenantSettings';
import {
    resolveEntityLabels,
    applyEntityLabelText,
    getEffectiveFormFieldMap,
    applyEntityLabelsToColumns,
    patchLookupMetaLabel,
    hasCustomEntityLabels,
} from '../utils/entityLabels';
import { getLookupMeta as getBaseLookupMeta } from '../utils/lookupModalSettings';

/**
 * Tenant-specific entity terminology (e.g. Commodity → Product).
 */
export function useEntityLabels() {
    const { data: tenantSettings } = useTenantSettings();

    const labels = useMemo(
        () => resolveEntityLabels(tenantSettings),
        [tenantSettings]
    );

    const t = useCallback(
        (text) => applyEntityLabelText(text, labels),
        [labels]
    );

    const formFieldMap = useMemo(
        () => getEffectiveFormFieldMap(labels),
        [labels]
    );

    const getLookupMeta = useCallback(
        (lookupType) => patchLookupMetaLabel(lookupType, getBaseLookupMeta(lookupType), labels),
        [labels]
    );

    const mapColumns = useCallback(
        (columns) => applyEntityLabelsToColumns(columns, labels),
        [labels]
    );

    return useMemo(
        () => ({
            labels,
            commodity: labels.commodity,
            account: labels.account,
            location: labels.location,
            laArea: labels.laArea,
            t,
            formFieldMap,
            getLookupMeta,
            mapColumns,
            isDefault: !hasCustomEntityLabels(labels),
        }),
        [labels, t, formFieldMap, getLookupMeta, mapColumns]
    );
}
